import { connect } from 'react-redux';
import { compose, hoistStatics, withPropsOnChange, withState } from 'recompose';
import { translate } from 'react-i18next';
import PageTitle from './PageTitle';
import { settingsActions } from '../../reducers/settings';
import fsh from '../../helpers/fromSubscriber.helper';

const mapStateToProps = state => ({
  subscriber: state.settings.subscriber,
});


const mapDispatchToProps = {
  setPageTitle: settingsActions.updateSettings,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  withState('htmlTitle', 'setHtmlTitle', ''),
  withPropsOnChange(['title'], (props) => {
    const {
      title,
      subscriber,
      titleForHtml,
      setPageTitle,
      pageSubTitle,
      setHtmlTitle,
      backgroundPage,
      backgroundCover,
      enableCoverColor,
    } = props;

    setPageTitle({
      pageTitle: title,
      enableCoverColor,
      backgroundPage,
      backgroundCover,
      pageSubTitle: pageSubTitle || '',
    });

    const newTitle = title || titleForHtml || props.t('Homepage');
    setHtmlTitle(fsh.createTitle({ slogan: subscriber && subscriber.slogan,
      company: subscriber && subscriber.title }) || newTitle);
  }),
);

export default hoistStatics(enhance)(PageTitle);



// WEBPACK FOOTER //
// ./src/components/pageTitle/index.js